import ListedFailed from "@/assetsV3/marketplace/ListedFailed";

export const ListFailStep = () => {

  return (
    <div className="flex gap-[11px] w-full h-full justify-center items-center flex-col p-6">
      <ListedFailed />
      <span className="text-[21px] font-bold font-inter text-outext-main">
      Failed
      </span>
      <span className="text-base text-center font-normal font-inter text-outext-sub">
      Transaction failed.
      </span>
    </div>
  );
};
